import SelectIndustry from './SelectIndustry';

export default SelectIndustry;
